import LoginComponent from '@/components/login-component';
import { useTranslations } from 'next-intl';

const LoginPage = () => {
  const t = useTranslations('Pages.Login');
  return <LoginComponent title={t('sign_in')} view="sign_in" />;
};

export default LoginPage;
